/* Robols: ficha de producto A21 (sections/robols-ficha.liquid).
   - Cambiar de tamaño es instantáneo: los datos de cada tamaño ya vienen en la página.
   - "Agregar al carrito" es el formulario de siempre (product-form.js + carrito lateral).
   - Nada escucha el scroll: la galería, la barra fija y el set de decants usan IntersectionObserver.
   - La barra fija funciona igual que en la A17: su texto sale de textoBarra() (textoBoton(), salvo "Agregar preventa" con
     una botella en preventa); "(Preventa)" solo va en el botón grande. */
(function () {
  var raiz = document.querySelector('[data-rf]');
  if (!raiz || raiz.rfListo) return;
  raiz.rfListo = true;

  var datos;
  try { datos = JSON.parse(raiz.querySelector('[data-rf-datos]').textContent); } catch (e) { return; }
  function $(s, c) { return (c || raiz).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || raiz).querySelectorAll(s)); }
  var V = {};
  datos.variantes.forEach(function (v) { V[v.id] = v; });

  var form = $('form[data-type="add-to-cart-form"]');
  var campo = form && form.querySelector('input[name="id"]');
  var cta = $('[data-rf-cta]');
  var ctaTexto = cta && cta.querySelector('span');
  var elegida = V[campo && campo.value] || datos.variantes[0];
  var celular = window.matchMedia('(max-width: 749px)');

  var pesos = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 0 });
  var centavos = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function dinero(c) {
    var n = c / 100;
    return '$' + (n % 1 ? centavos : pesos).format(n);
  }
  /* Lo que no se ve (dirección de la página, avisos a las estadísticas de Shopify, foto, set) va justo
     después de que el cambio ya se pintó, para que el toque responda al instante. */
  function despues(fn) {
    requestAnimationFrame(function () { setTimeout(fn, 0); });
  }
  /* Indicador de existencias: v.x (en preventa, con sus piezas como un perfume normal); v.e si no viene.
     Botella en preventa (25 oct 2026, pedido de Héctor): lo de siempre + " (Preventa)"; si ya dice "Preventa", no se repite */
  function existencias(v) {
    var e = v.x || v.e, pre = v.e === 'preventa' && !v.d ? ' (Preventa)' : '';
    /* Pocas piezas (29 sep 2026, pedido de Héctor): "Quedan solo N piezas" / "Queda solo 1 pieza" */
    if (e === 'pocas') return [(v.q === 1 ? 'Queda solo 1 pieza' : 'Quedan solo ' + v.q + ' piezas') + pre, '#F0B35A'];
    if (e === 'preventa') return ['Preventa', '#d9d9d9'];
    if (e === 'agotado') return ['Agotado', '#8c8c8c'];
    return ['En existencia' + pre, '#5DBB63'];
  }
  function textoBoton(v) {
    return v.e === 'agotado' ? 'Solicitar perfume' : 'Agregar al carrito';
  }
  /* Botón grande: con una botella en preventa dice "Agregar al carrito (Preventa)"; la barra fija no cambia */
  function textoPrincipal(v) {
    return v.e === 'preventa' && !v.d ? 'Agregar al carrito (Preventa)' : textoBoton(v);
  }
  /* Barra fija: con una botella en preventa dice "Agregar preventa" (29 sep 2026, pedido de Héctor); lo demás, igual */
  function textoBarra(v) {
    return v.e === 'preventa' && !v.d ? 'Agregar preventa' : textoBoton(v);
  }

  /* ---------- Elegir tamaño ---------- */
  function pintar(v) {
    elegida = v;
    $$('[data-rf-variante]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-rf-variante')) === String(v.id) ? 'true' : 'false');
    });
    var precio = $('[data-rf-precio]'), antes = $('[data-rf-antes]'), ahorro = $('[data-rf-ahorro]');
    precio.textContent = dinero(v.p);
    /* Agotado: sin precio anterior ni ahorro, con "Agotado por ahora" */
    antes.textContent = v.c > v.p && v.e !== 'agotado' ? dinero(v.c) : '';
    ahorro.textContent = v.c > v.p && !v.d && v.e !== 'agotado' ? 'Ahorras ' + dinero(v.c - v.p) : '';
    $('[data-rf-agotado]').hidden = v.e !== 'agotado';
    /* Línea de estado bajo el precio: existencias del tamaño elegido y cuándo llega (sin "recibe…" en preventa) */
    var ex = existencias(v), estado = $('[data-rf-estado]');
    if (estado) {
      estado.querySelector('[data-rf-punto]').style.background = ex[1];
      estado.querySelector('[data-rf-existencias]').textContent = ex[0];
      estado.querySelector('[data-rf-llega]').textContent = v.e === 'preventa' || v.e === 'agotado' ? '' : '· recibe en 1–3 días hábiles';
    }
    var preventaBotella = v.e === 'preventa' && !v.d;
    var aviso = $('[data-rf-aviso-preventa]');
    if (aviso) aviso.hidden = !preventaBotella;
    /* "¿Cómo funciona una preventa?" solo con la botella en preventa elegida */
    var btnPre = $('[data-rf-preventa-btn]');
    if (btnPre) btnPre.hidden = !preventaBotella;
    $('[data-rf-sello]').hidden = !preventaBotella;
    if (ctaTexto) ctaTexto.textContent = textoPrincipal(v);
    /* La bolsita solo cuando se agrega al carrito; en "Solicitar perfume" se oculta */
    if (cta) cta.classList.toggle('is-solicitar', v.e === 'agotado');
    var ahora = $('[data-rf-ahora]');
    if (ahora) ahora.hidden = v.e === 'agotado';
    var tam = document.querySelector('[data-rf-barra-tam]'), bp = document.querySelector('[data-rf-barra-precio]'), bb = document.querySelector('[data-rf-barra-btn-texto]');
    if (tam) tam.textContent = v.l;
    if (bp) bp.textContent = dinero(v.p);
    if (bb) bb.textContent = textoBarra(v);
    var bbtn = document.querySelector('[data-rf-barra-btn]');
    if (bbtn) bbtn.classList.toggle('is-solicitar', v.e === 'agotado');
    var js = $('[data-selected-variant]');
    if (js) js.textContent = JSON.stringify({ id: v.id, title: v.t, name: datos.titulo + ' - ' + v.t, price: v.p, featured_image: v.img ? { src: v.img } : null });
    var avisar = false;
    if (campo && String(campo.value) !== String(v.id)) {
      campo.value = v.id;
      avisar = true;
    }
    actualizarSet();
    despues(function () {
      if (elegida !== v) return;
      if (avisar) campo.dispatchEvent(new Event('change', { bubbles: true }));
      try { history.replaceState(history.state, '', datos.url + '?variant=' + v.id); } catch (err) {}
      if (v.m) irAFoto(v.m);
    });
  }
  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rf-variante]');
    if (!b || !raiz.contains(b)) return;
    var v = V[b.getAttribute('data-rf-variante')];
    if (!v || v === elegida) return;
    pintar(v);
  });

  /* ---------- ¿Qué es un decant? / ¿Cómo funciona la preventa? (se abren al tocar) ---------- */
  $$('[data-rf-quees]').forEach(function (quees) {
    quees.addEventListener('click', function () {
      var p = document.getElementById(quees.getAttribute('aria-controls'));
      var abrir = quees.getAttribute('aria-expanded') !== 'true';
      quees.setAttribute('aria-expanded', String(abrir));
      if (p) p.hidden = !abrir;
    });
  });

  /* ---------- Galería ---------- */
  var pista = $('[data-rf-pista]');
  var diapos = $$('[data-rf-diapo]');
  var actual = $('[data-rf-actual]'), puntos = $$('.rf-punto'), minis = $$('[data-rf-mini]');
  function marcar(i) {
    if (actual) actual.textContent = i + 1;
    puntos.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
    minis.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
  }
  if (pista && diapos.length > 1 && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) marcar(parseInt(en.target.getAttribute('data-indice'), 10) || 0); });
    }, { root: pista, threshold: 0.6 });
    diapos.forEach(function (d) { obs.observe(d); });
  }
  function irA(i, suave) {
    var d = diapos[i];
    if (!d || !pista) return;
    pista.scrollTo({ left: d.offsetLeft - pista.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
    marcar(i);
  }
  function irAFoto(mediaId) {
    for (var i = 0; i < diapos.length; i++) {
      if (String(diapos[i].getAttribute('data-media-id')) === String(mediaId)) { irA(i, true); return; }
    }
  }
  minis.forEach(function (m) {
    m.addEventListener('click', function () { irA(parseInt(m.getAttribute('data-rf-mini'), 10) || 0, true); });
  });
  var lupa = $('[data-rf-lupa]');
  if (lupa && lupa.showModal) {
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rf-lupa-abre]');
      if (!b) return;
      var d = b.closest('[data-rf-diapo]'), id = d && d.getAttribute('data-media-id');
      lupa.showModal();
      document.documentElement.style.overflow = 'hidden';
      var f = id && lupa.querySelector('[data-media-id="' + id + '"]');
      lupa.scrollTop = f ? f.offsetTop - 56 : 0;
    });
    var cerrar = function () { if (lupa.open) lupa.close(); };
    lupa.addEventListener('click', function (e) { if (e.target.closest('[data-rf-lupa-cierra]') || e.target === lupa) cerrar(); });
    lupa.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
  }

  /* ---------- Barra fija (celular): aparece solo cuando el botón principal no se ve completo ---------- */
  /* La barra puede estar ya al final de la página: robols-navegacion la pasa ahí y la hace subir en cuanto se lee,
     sin esperar a este archivo. Por eso se busca en toda la página y no se vuelve a mover (moverla cortaría su
     animación de entrada). */
  var barra = $('[data-rf-barra]') || document.querySelector('[data-rf-barra]');
  if (barra && cta && 'IntersectionObserver' in window) {
    if (barra.parentNode !== document.body) document.body.appendChild(barra);
    var completo = true;
    var mostrar = function () {
      var si = !completo && celular.matches;
      barra.classList.toggle('is-visible', si);
      barra.setAttribute('aria-hidden', si ? 'false' : 'true');
      $$('button', barra).forEach(function (b) { b.tabIndex = si ? 0 : -1; });
      document.documentElement.classList.toggle('rf-barra-on', si);
    };
    new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { completo = en.intersectionRatio >= 0.99; });
      mostrar();
    }, { threshold: [0, 0.99, 1] }).observe(cta);
    if (celular.addEventListener) celular.addEventListener('change', mostrar);
    barra.querySelector('[data-rf-barra-btn]').addEventListener('click', function () { cta.click(); });
    barra.querySelector('[data-rf-barra-info]').addEventListener('click', function () {
      var destino = $('.rf-tamanos') || cta;
      var enc = document.querySelector('.section-header, sticky-header');
      var alto = enc ? Math.max(0, enc.getBoundingClientRect().bottom) : 0;
      var y = destino.getBoundingClientRect().top + window.pageYOffset - alto - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    raiz.rfBarra = mostrar;
  }

  /* ---------- Solicitar perfume: con el tamaño elegido agotado, el botón (y el de la barra fija, que lo toca)
     abre WhatsApp con el perfume y el tamaño ya escritos. Sin sesión ni formulario (1 nov 2026, pedido de Héctor:
     la solicitud por la tienda no funcionaba). ---------- */
  var telWhatsapp = cta && cta.getAttribute('data-rf-whatsapp');
  if (cta && telWhatsapp) cta.addEventListener('click', function (e) {
    if (!elegida || elegida.e !== 'agotado') return;
    e.preventDefault();
    e.stopPropagation();
    var tam = !elegida.t || elegida.t === 'Default Title' ? '' : ' (' + elegida.t + ')';
    var url = 'https://wa.me/' + telWhatsapp + '?text=' + encodeURIComponent('Hola, quiero solicitar el perfume ' + datos.titulo + tam + '.');
    var w = window.open(url, '_blank');
    if (w) w.opener = null; else location.href = url;
  }, true);

  /* ---------- Se pide algo solo cuando el cliente se acerca (sin escuchar el scroll) ---------- */
  function alAcercarse(el, fn) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { (window.requestIdleCallback || setTimeout)(fn); return; }
    var io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        if (ents[i].isIntersecting) { io.disconnect(); fn(); return; }
      }
    }, { rootMargin: '900px 0px 900px 0px' });
    io.observe(el);
  }

  /* ---------- Arma tu set de decants: sección propia, siempre visible si el perfume tiene decants ----------
     Las 3 sugerencias se piden cuando el cliente se acerca; mientras, 3 renglones vacíos guardan su lugar. */
  var set = $('[data-rf-set]');
  var cargado = false;
  function cajon() { return document.querySelector('cart-drawer'); }
  function enCarrito(id) { var c = cajon(); return !!(c && c.querySelector('[data-variante="' + id + '"]')); }
  function actualizarSet() {
    if (!set) return;
    $$('[data-rf-candidato]', set).forEach(function (f) {
      var b = f.querySelector('button[name="add"]'), si = enCarrito(f.getAttribute('data-variante'));
      if (!b) return;
      b.classList.toggle('is-agregado', si);
      b.querySelector('span').textContent = si ? 'Agregado' : '+ Agregar';
    });
  }
  /* "Cítrico" → "cítricos", "Fresco especiado" → "frescos especiados", "Floral" → "florales" */
  function plural(fam) {
    var hecho = false;
    return fam.toLowerCase().split(' ').map(function (w) {
      if (hecho || w === 'de') { hecho = true; return w; }
      if (/s$/.test(w)) return w;
      if (/z$/.test(w)) return w.slice(0, -1) + 'ces';
      if (/[aeiouáéíóú]$/.test(w)) return w + 's';
      return w + 'es';
    }).join(' ');
  }
  function quitarSet() { if (set) { set.remove(); set = null; } }
  function cargarSet() {
    if (!set || cargado) return;
    cargado = true;
    var familias = (($('[data-rf-familias]') || { getAttribute: function () { return ''; } }).getAttribute('data-rf-familias') || '').split('|').filter(Boolean);
    var url = datos.reco + '?section_id=robols-ficha-set&product_id=' + datos.producto + '&limit=10&intent=related';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!set) return;
      if (!html) { quitarSet(); return; }
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var cands = $$('[data-rf-candidato]', tmp).filter(function (c) { return c.getAttribute('data-rf-candidato') !== String(datos.producto); });
      cands.forEach(function (c, i) {
        var f = (c.getAttribute('data-familias') || '').split('|');
        var comunes = familias.filter(function (x) { return f.indexOf(x) !== -1; });
        c.rfPuntos = (familias[0] && f.indexOf(familias[0]) !== -1 ? 10 : 0) + comunes.length - i / 100;
      });
      cands.sort(function (a, b) { return b.rfPuntos - a.rfPuntos; });
      var elegidos = cands.slice(0, 3);
      if (!elegidos.length) { quitarSet(); return; }
      /* Subtítulo: las familias del perfume que también tienen las sugerencias (máximo 2) */
      var compartidas = familias.filter(function (x) {
        return elegidos.some(function (c) { return (c.getAttribute('data-familias') || '').split('|').indexOf(x) !== -1; });
      }).slice(0, 2);
      var sub = $('[data-rf-set-sub]', set);
      if (sub) sub.textContent = compartidas.length ? 'También ' + compartidas.map(plural).join(' y ') + ', en 5 ml' : 'Otros decants de 5 ml';
      var lista = $('[data-rf-set-lista]', set);
      lista.textContent = '';
      elegidos.forEach(function (c) { lista.appendChild(c); });
      actualizarSet();
    }).catch(quitarSet);
  }
  if (set) {
    set.addEventListener('submit', function (e) {
      var b = e.target.querySelector('button[name="add"]');
      if (b) { b.classList.add('is-agregado'); b.querySelector('span').textContent = 'Agregado'; }
      /* Si Shopify no lo agregó (por ejemplo, sin señal), el botón vuelve a decir lo que hay en el carrito */
      setTimeout(actualizarSet, 8000);
    }, true);
    var espera = 0, c = cajon();
    var alCambiarCajon = function () {
      if (espera) return;
      espera = requestAnimationFrame(function () { espera = 0; actualizarSet(); });
    };
    if (c) {
      new MutationObserver(alCambiarCajon).observe(c, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-total', 'data-cantidad'] });
      new MutationObserver(alCambiarCajon).observe(c, { attributes: true, attributeFilter: ['class'] });
    }
    alAcercarse(set, cargarSet);
  }

  /* ---------- Agotado: "Parecidos y disponibles" (3 recomendados que sí se pueden comprar) ---------- */
  var parecidos = $('[data-rf-parecidos]');
  alAcercarse(parecidos, function () {
    var url = datos.reco + '?section_id=robols-ficha-parecidos&product_id=' + datos.producto + '&limit=10&intent=related';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html || '';
      var items = $$('[data-rf-parecido]', tmp).filter(function (a) { return a.getAttribute('data-rf-parecido') !== String(datos.producto); }).slice(0, 3);
      if (!items.length) { parecidos.remove(); return; }
      var lista = $('[data-rf-parecidos-lista]', parecidos);
      lista.textContent = '';
      items.forEach(function (a) { lista.appendChild(a); });
    }).catch(function () { parecidos.remove(); });
  });

  /* ---------- "Ver las N reseñas": al widget completo de Loox ---------- */
  var todas = $('[data-rf-todas]');
  if (todas) todas.addEventListener('click', function (e) {
    var destino = document.getElementById('looxReviews') || document.querySelector('[id*="loox" i], .loox-reviews-default');
    if (!destino) return;
    e.preventDefault();
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Lupa como paso del historial (igual que el carrito lateral) ----------
     Abrir una foto en grande agrega un paso: "atrás" cierra la lupa y el cliente se queda en el perfume, y
     "adelante" la vuelve a abrir en la misma foto. Cerrarla con la X, tocando afuera o con Esc regresa ese paso,
     así no queda un "atrás" que no hace nada. Si Safari ya no tenía guardada la página y la vuelve a cargar en ese
     paso, la lupa se abre en su foto. */
  if (lupa && lupa.showModal) {
    var enLupa = function () { return !!(history.state && history.state.robolsLupa); };
    var abrirLupa = function (id) {
      if (!lupa.open) lupa.showModal();
      document.documentElement.style.overflow = 'hidden';
      var f = id && lupa.querySelector('[data-media-id="' + id + '"]');
      lupa.scrollTop = f ? f.offsetTop - 56 : 0;
    };
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rf-lupa-abre]');
      if (!b || !lupa.open || enLupa()) return;
      var d = b.closest('[data-rf-diapo]');
      try {
        var s = history.state, paso = {};
        if (s && typeof s === 'object') for (var k in s) if (k !== 'rvPaso' && k !== 'robolsCarrito') paso[k] = s[k];
        paso.robolsLupa = true;
        paso.rfFoto = (d && d.getAttribute('data-media-id')) || '';
        history.pushState(paso, '', location.href);
      } catch (err) {}
    });
    lupa.addEventListener('close', function () { if (enLupa()) history.back(); });
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.robolsLupa) abrirLupa(e.state.rfFoto);
      else if (lupa.open) lupa.close();
    });
    if (enLupa()) abrirLupa(history.state.rfFoto);
  }


  /* ---------- "Ver la descripción completa" (Cómo huele): panel con la descripción, como la lupa ----------
     El texto es el de "Sobre este perfume" (se copia al abrir por primera vez; no se descarga nada).
     Abrir agrega un paso al historial: "atrás" cierra el panel y el cliente queda donde estaba; cerrarlo con la X,
     tocando afuera o con Esc regresa ese paso. */
  var desc = $('[data-rf-desc]');
  if (desc && desc.showModal) {
    var descTexto = $('[data-rf-desc-texto]', desc);
    var descCaja = $('.rf-desc__caja', desc);
    var enDesc = function () { return !!(history.state && history.state.robolsDesc); };
    /* Cerrar con animación: se pone .is-cerrando, y al terminar (o a los 320 ms, por si acaso) se cierra de verdad */
    var cerrando = false;
    var cerrarDesc = function () {
      if (!desc.open || cerrando) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { desc.close(); return; }
      cerrando = true;
      desc.classList.add('is-cerrando');
      var listo = function () {
        desc.removeEventListener('animationend', alTerminar);
        if (!cerrando) return;
        cerrando = false;
        desc.classList.remove('is-cerrando');
        desc.close();
      };
      var alTerminar = function (e) { if (e.target === desc && !e.pseudoElement) listo(); };
      desc.addEventListener('animationend', alTerminar);
      setTimeout(listo, 320);
    };
    var abrirDesc = function () {
      if (cerrando) { cerrando = false; desc.classList.remove('is-cerrando'); }
      if (descTexto && !descTexto.firstChild) {
        var fuente = $('.rf-mas .rf-acordeon__texto');
        if (fuente) descTexto.innerHTML = fuente.innerHTML;
      }
      if (!desc.open) desc.showModal();
      /* El foco va al contenido y no a la X: en iPhone, si la X recibe el foco al abrir, se queda con el aro azul */
      if (descCaja) { descCaja.setAttribute('tabindex', '-1'); descCaja.focus({ preventScroll: true }); }
      document.documentElement.style.overflow = 'hidden';
    };
    raiz.addEventListener('click', function (e) {
      if (!e.target.closest('[data-rf-desc-abre]')) return;
      if (descTexto) descTexto.scrollTop = 0;
      abrirDesc();
      try {
        var s = history.state, paso = {};
        if (s && typeof s === 'object') for (var k in s) if (k !== 'rvPaso' && k !== 'robolsCarrito' && k !== 'robolsLupa') paso[k] = s[k];
        paso.robolsDesc = true;
        history.pushState(paso, '', location.href);
      } catch (err) {}
    });
    desc.addEventListener('click', function (e) {
      if (e.target.closest('[data-rf-desc-cierra]') || e.target === desc) cerrarDesc();
    });
    desc.addEventListener('cancel', function (e) { e.preventDefault(); cerrarDesc(); });
    desc.addEventListener('close', function () {
      cerrando = false;
      desc.classList.remove('is-cerrando');
      document.documentElement.style.overflow = '';
      if (enDesc()) history.back();
    });
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.robolsDesc) abrirDesc();
      else if (desc.open) cerrarDesc();
    });
    if (enDesc()) abrirDesc();
  }

})();
